import { useFlags } from 'launchdarkly-react-client-sdk';

// Same killswitch Armageddon checks -- see LaunchDarklyFlags::PhoneIdentity::OPERATIONAL and
// PhoneNumbers::VerificationGate in Armageddon. Armageddon's gate is authoritative and can
// target per-user (it has user id + email in its LD context); the marketplace frontend cannot
// (its LD context is keyed on a session id with no email -- see use-user-controller.tsx). So this
// flag's only job on the frontend is to act as a circuit breaker that skips the `status` network
// call entirely when the feature is switched off, not to make any rollout decision of its own.
const PHONE_IDENTITY_OPERATIONAL_FLAG = 'ecomm.phone-identity.operational';

/**
 * Whether the phone-verification Nudge is operationally enabled on the frontend. This is a
 * killswitch, not a rollout dial: it defaults to TRUE when the flag is absent or unavailable
 * (e.g. LD hasn't initialized yet), because an absent/unavailable flag must never silently
 * disable the feature. Do not "fix" this to `?? false` -- see the rollout-flag convention
 * elsewhere in this app, which is deliberately the opposite of this one.
 */
export function usePhoneVerificationNudgeOperational(): boolean {
  const flags = useFlags();

  return Boolean(flags[PHONE_IDENTITY_OPERATIONAL_FLAG] ?? true);
}
